module.exports = __webpack_public_path__ + "static/media/orderDeclined.afe4aa71.svg";